import React from 'react';

var FooterContainer = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-game-footer' }, children);
};

export { FooterContainer };
